import { render, staticRenderFns } from "./TeamInbox.vue?vue&type=template&id=095f4c4e&scoped=true&"
import script from "./TeamInbox.vue?vue&type=script&lang=js&"
export * from "./TeamInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095f4c4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095f4c4e')) {
      api.createRecord('095f4c4e', component.options)
    } else {
      api.reload('095f4c4e', component.options)
    }
    module.hot.accept("./TeamInbox.vue?vue&type=template&id=095f4c4e&scoped=true&", function () {
      api.rerender('095f4c4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TeamInbox/TeamInbox.vue"
export default component.exports